import {AfterViewInit, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {GlOnClose, GoldenLayoutContainer} from 'ngx-golden-layout';
import GoldenLayout from 'golden-layout';
import {TransportInterventionsPageRequest} from './transport-interventions-page-request';
import {
  MenuItem,
  TransportInterventionsNavigationService
} from '../transport-interventions-navigation/transport-interventions-navigation.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-transport-interventions-page',
  templateUrl: './transport-interventions-page.component.html',
  styleUrls: ['./transport-interventions-page.component.scss']
})
export class TransportInterventionsPageComponent implements OnInit, OnDestroy, AfterViewInit, GlOnClose {

  currentMenu: MenuItem;
  backgroundMenu: MenuItem;
  request: TransportInterventionsPageRequest = new TransportInterventionsPageRequest();

  width: number;
  height: number;
  private navigationSub: Subscription;

  constructor(
    @Inject(GoldenLayoutContainer) private container: GoldenLayout.Container,
    private transportNavigationService: TransportInterventionsNavigationService,
  ) {
    this.currentMenu = transportNavigationService.current;
    this.backgroundMenu = transportNavigationService.backgroundMenu;
  }

  ngOnInit(): void {
    this.width = this.container.getElement().width();
    this.height = this.container.getElement().height() - 50;

    this.navigationSub = this.transportNavigationService.navigate$.subscribe(m => {
      this.currentMenu = m.current;
      this.backgroundMenu = m.background;
    });
  }

  ngOnDestroy(): void {
    this.navigationSub.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.request.submit();
  }

  glOnClose(): Promise<void> {
    this.transportNavigationService.navigateById(1);
    return Promise.resolve(undefined);
  }

}
